import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description CompareAdded icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { CompareAdded } from '@sravni/design-system-icons'
 *
 * <CompareAdded />
 * ```
 */
var CompareAdded = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "CompareAdded", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: "3", y: "11", width: "6.5", height: "1.5", rx: ".75", fill: "currentColor" }),
    React.createElement("rect", { x: "3", y: "15", width: "6.5", height: "1.5", rx: ".75", fill: "currentColor" }),
    React.createElement("rect", { x: "3", y: "3", width: "14", height: "1.5", rx: ".75", fill: "currentColor" }),
    React.createElement("rect", { x: "3", y: "7", width: "14", height: "1.5", rx: ".75", fill: "currentColor" }),
    React.createElement("path", { d: "m17 12-3.438 4L12 14.182", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { CompareAdded };
//# sourceMappingURL=CompareAdded.js.map
